<script lang="ts" setup>
import { PropType } from 'vue';
import { Expense } from '@/models/expense';
import ExpenseItem from './ExpenseItem.vue';

const { expenses } = defineProps({
  expenses: {
    type: Array as PropType<Expense[]>,
    required: true,
  },
});
</script>
<template>
  <section class="section">
    <h3>Expenses</h3>
    <ul class="compound" v-if="expenses.length">
      <ExpenseItem
        v-for="expense in expenses"
        :key="expense.id"
        :expense="expense"
      ></ExpenseItem>
    </ul>
    <p v-else>There are no expenses for this period.</p>
  </section>
</template>
